import Image from '@/components/Image';
import { EProductItemTagType } from '@/utils/enums/goods';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import WapOnly from '../Responsive/WapOnly';
import WebOnly from '../Responsive/WebOnly';
/*
 * @Author: Gao Deng gaodeng@nextmar.com
 * @Date: 2025-04-18 00:34:17
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-07-18 13:43:43
 * @FilePath: /code/zeelool-nextjs/src/components/Product/ProductItemTag.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
function ProductItemTag({
  type,
  labelText = '',
  className = '',
  labelImage = '',
}: {
  type?: 3 | 4 | 5 | 6 | 7 | 'extra' | 'member_only';
  labelText?: string;
  className?: string;
  labelImage?: string;
}) {
  const productItemTagTypeI18n = {
    'Package Set': 'packageSet',
    Gift: 'gift',
    Redeemed: 'redeemed',
    Seckill: 'seckill',
    'Extra Gift': 'extraGift',
    'Exclusive Item': 'exclusiveItem',
  };
  const [label] = useState(labelText || (type && EProductItemTagType[type]) || '');
  const t = useTranslations('productItemTag');
  if (!label && !labelImage) return null;

  return (
    <>
      <WebOnly>
        <div
          className={`inline-block p-[0_4px_2px] h-[16] leading-14 rounded-[2px] text-12 border-1 border-solid border-primary-purple text-primary-purple ${className}`}
        >
          {Object.keys(productItemTagTypeI18n).includes(label)
            ? t(productItemTagTypeI18n[label])
            : label}
        </div>
      </WebOnly>
      <WapOnly>
        <>
          <div
            className={`inline-flex items-center font-br ${
              [4, 6].includes(type as number) || labelText
                ? 'absolute top-0 left-0 bg-auxiliary-lilac-purple h-[16px] leading-[16px] p-[0_7px] rounded-[8px_0_8px_0] text-10 text-primary-black'
                : ''
            } ${type === 'extra' ? 'absolute top-0 left-0 w-[80px] h-[80px]' : ''} ${
              [5, 3, 'member_only'].includes(type)
                ? 'absolute bottom-0 w-full h-[18px] text-10 text-center justify-center bg-auxiliary-light-purple rounded-[0_0_8px_8px]'
                : ''
            } ${
              type === 7 && !!labelImage ? 'absolute top-0 left-0 h-[16px] w-auto' : ''
            }${type === 7 && !labelImage ? 'absolute top-0 left-0 bg-[ECA6FF] h-[16px] leading-[16px] p-[0_7px] rounded-[8px_0_8px_0] text-10 text-primary-black' : ''}`}
          >
            {type === 7 && !!labelImage && (
              <Image
                className="h-[16px] w-auto"
                src={labelImage}
                alt="Seckill"
                width={48}
                height={16}
                unoptimized
              />
            )}
            {type === 'extra' && (
              <Image
                className="w-full h-full"
                src="/gift_sign.png"
                alt="gift"
                width={80}
                height={80}
              />
            )}
            {!((type === 7 && !!labelImage) || type === 'extra') && !!label && (
              <span>
                {Object.keys(productItemTagTypeI18n).includes(label)
                  ? t(productItemTagTypeI18n[label])
                  : label}
              </span>
            )}
          </div>
        </>
      </WapOnly>
    </>
  );
}

export default ProductItemTag;
